export const ADD_QUESTION_REQUEST = "ADD_QUESTION_REQUEST";
export const ADD_QUESTION_SUCCESS = "ADD_QUESTION_SUCCESS";
export const GET_INTERVIEW_REQUEST = "GET_INTERVIEW_REQUEST";
export const GET_INTERVIEW_SUCCESS = "GET_INTERVIEW_SUCCESS";
export const CREATE_INTERVIEW_REQUEST = "CREATE_INTERVIEW_REQUEST";
export const CREATE_INTERVIEW_SUCCESS = "CREATE_INTERVIEW_SUCCESS";
export const REQUEST_FAIL = "REQUEST_FAIL";
export const GETMY_QUESTIONS_REQUEST = "GETMY_QUESTIONS_REQUEST";
export const GETMY_QUESTIONS_SUCCESS = "GETMY_QUESTIONS_SUCCESS";
export const ADD_TO_STARRED_REQUEST = "ADD_TO_STARRED_REQUEST";
export const ADD_TO_STARRED_SUCCESS = "ADD_TO_STARRED_SUCCESS";
export const GET_STARRED_REQUEST = "GET_STARRED_REQUEST";
export const GET_STARRED_SUCCESS = "GET_STARRED_SUCCESS";
export const STARRED_INTERVIEW_REQUEST = "STARRED_INTERVIEW_REQUEST";
export const STARRED_INTERVIEW_SUCCESS = "STARRED_INTERVIEW_SUCCESS";
export const GET_STARRED_INTERVIEW_REQUEST = "GET_STARRED_INTERVIEW_REQUEST";
export const GET_STARRED_INTERVIEW_SUCCESS = "GET_STARRED_INTERVIEW_SUCCESS";